<template>
    <div class="apply_online" @click="isShow = false">
        <div class="title">请选择申请人</div>
        <div class="card_list">
            <div class="self card_item" @click.stop="togglePage('applyService')">
                <span class="iconfont iconwbrsq"></span>
                <p>为本人申请</p>
            </div>
            <div class="family card_item" @click.stop="familyApply()">
                <span class="iconfont iconwjrsq"></span>
                <p>为家人申请</p>
            </div>
        </div>
        <div class="toast" v-if="isShow">
            请先完善个人信息
            <div class="switch" @click="perfectHandle('personInfo')">去完善</div>
        </div>
    </div>
</template>

<script>
import { getIsComplateUserInfo } from "@/api/user.js";
import { mapState } from "vuex";
export default {
    name: "applyOnline",
    data() {
        return {
            isShow: false,
            hasUserInfo: "" //0表示用户信息以完善， 不等于零表示为完善用户信息
        };
    },
    methods: {
        togglePage(name) {
            if (this.hasUserInfo === 0) {
                this.$router.push(name);
                return;
            }
            this.isShow = true;
        },
        perfectHandle(name) {
            this.$router.push(name);
        },
        familyApply() {
            if (this.hasUserInfo === 0) {
                this.$router.push("familyApply");
                return;
            }
            this.isShow = true;
        },
        async checkUserInfo() {
            const { code } = await getIsComplateUserInfo({
                openId: this.openId
            });
            this.hasUserInfo = code;
        }
    },

    mounted() {
        window.document.title = "申请" + this.serviceName;
        this.checkUserInfo();
    },
    computed: {
        ...mapState("user", ["openId"]),
        ...mapState("service", ["serviceName"])
    }
};
</script>

<style lang="scss" scoped>
.apply_online {
    width: 100vw;
    height: 100vh;
    .title {
        opacity: 1;
        font-size: 18px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: center;
        margin-top: 50px;
        color: #000000;
    }
    .card_list {
        margin-top: 20px;
        display: flex;
        padding-top: 30px;
        justify-content: space-around;
        .card_item {
          
            width: 120px;
            height: 120px;
            border-radius: 10px;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            padding-top: 25px;
            p {
              font-size: 16px;
              font-weight: 700;
              
            }

            &.self {
              box-shadow: 5px 5px 15px #d2eeff ;
                background-color: #d2eeff;
                span {
                  font-size: 40px;
                  margin: 0 50px;
                  color: #024154;
                }
                p {
                  color: #024154;
                }
            }

            &.family {
              box-shadow: 5px 5px 15px #ffd63c ;
                background-color: #ffd63c;
                span {
                    font-size: 40px;
                  margin: 0 50px;
                  color: #543302;
                }
                p {
                  color: #543302;
                }
            }
        }
    }
    .toast {
        margin: 0 auto;
        width: 225px;
        height: 103px;
        opacity: 1;
        background: #626262;
        border-radius: 8px;
        opacity: 1;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Bold;
        font-weight: 700;
        text-align: center;
        color: #ffffff;
        line-height: 50px;
        .switch {
            width: 77px;
            height: 24px;
            opacity: 1;
            background: #ffd63c;
            border-radius: 12px;
            opacity: 1;
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            color: #543302;
            line-height: 24px;
            margin: 0 auto;
            text-align: center;
        }
    }
}
</style>
